import React from "react"
import { associateQuestionTemplateIds, clearCategories, loadAssociatedQuestionTemplateIds, loadCategoriesQuestionsTree, loadCategoryNodes, loadSurveyTemplateCategories } from "../../../actions/categories";
import { showDialog } from "../../../actions/dialog";
import { clearActiveMenuItem, setActiveMenuItem, setupMenu, updateMenuRoot } from "../../../actions/menu";
import { CategoriesStore } from "../../../stores/categories";
import M from "../../../strings";
import { CategoriesTreeSelector } from "../../components/categoriesTreeSelectorControl";
import EntitiesGridControl from "../../components/entitiesGridControl";
import { QuestionsTreeSelector } from "../../components/questionsTreeSelectorControl";
import { Wizard } from "../../components/wizard"
import { Layout, Screen, SideBar } from "../../components/layout"
import { PAGES } from "../../../model/vars";
import { getSurveyTemplateMenu, MENU_ITEM_TYPES } from "../../../model/menu";
import { HeaderBlockWithBreadcrumbs } from "../../components/common";
import { Query } from "../../../framework/query";
import { getLoggedUser } from "../../../api/session";
import { secureScreen } from "../../components/secure";


class _SurveyTemplateQuestionsForm extends Screen {
    componentDidMount() {
        CategoriesStore.subscribe(this, state => {
            this.setState({
                categoryIds: state.selectedCategoryIds,
                questionsTree: state.questionsTree,
                categoryNodes: state.categoryNodes,
                selectedQuestionTemplateIds: state.selectedQuestionTemplateIds
            }) 
        });
    
        const id = this.props.entityId;

        if (id) {
            updateMenuRoot({
                root: getSurveyTemplateMenu(id)
            });

            setActiveMenuItem({id: "surveyTemplate.questions"});
        }


        const surveyTemplateId = this.props.entityId;
        if (surveyTemplateId) {
            loadCategoryNodes();
            loadSurveyTemplateCategories({surveyTemplateId});            
        }
    }

    componentWillUnmount() {
        CategoriesStore.unsubscribe(this);

        clearCategories();

        clearActiveMenuItem();
        setupMenu({user: getLoggedUser()});
    }

    onLoadQuestionNodes() {
        loadCategoriesQuestionsTree({categoryIds: this.state.categoryIds})
        const surveyTemplateId = this.props.entityId;
        if (surveyTemplateId) {
            loadAssociatedQuestionTemplateIds({surveyTemplateId, categoryIds: this.state.categoryIds})
        }
    }

    async onAssociate() {
        const surveyTemplateId = this.props.entityId;
        if (surveyTemplateId) {
            await associateQuestionTemplateIds({surveyTemplateId, questionTemplateIds: this.state.selectedQuestionTemplateIds});
            this.refs.grid.reload();
        }
    }

    onSelectQuestions() {
        showDialog({
            large: true,
            mobile: true,
            title: M("questionsAssociation"),
            getContent: () => (
                <Wizard onFinish={this.onAssociate.bind(this)} finishText={M("save")}>
                    <Wizard.Step id="red" subtitle={M("selectCategories")}>
                        <div className="p-32">
                            <CategoriesTreeSelector manualLoad={true} startsCollapsed={true} />
                        </div>
                    </Wizard.Step>
                    <Wizard.Step id="yellow" subtitle={M("selectQuestions")} onEnter={this.onLoadQuestionNodes.bind(this)}>
                        <div className="p-32">
                            <QuestionsTreeSelector manualLoad={true} startsCollapsed={true} />
                        </div>
                    </Wizard.Step>
                </Wizard>
            )
        })
    }

    getActions(data) {
        return [{
            type: "button",
            icon: "zmdi zmdi-collection-plus",
            tooltip: M("questionsManagement"),
            action: this.onSelectQuestions.bind(this)
        }];
    }

    getTitle() {
        return M("questionsCatalog")
    }

    render() {
        const id = this.props.entityId;

        if (!id) {
            throw new Error("Impossibile entrare nella schermata delle domande senza entity id");
        }

        return (
            <Layout>
                <SideBar/>
                <HeaderBlockWithBreadcrumbs title={this.getTitle()} actions={this.getActions()}/>
                <EntitiesGridControl ref={"grid"} initialQuery={() => new Query().eq("surveyTemplateId", id).hideFilter("surveyTemplateId")} entity={"question"} />
            </Layout>
        )
    }
}

export const SurveyTemplateQuestionsForm = secureScreen(_SurveyTemplateQuestionsForm)